export const readableDate = (scheduledAt: string) => {
  if (!scheduledAt) return;
  const pickupDate = new Date(Date.parse(scheduledAt)).toISOString();
  return `${pickupDate.slice(5, 7)}/${pickupDate.slice(8, 10)}/${pickupDate.slice(0, 4)}`;
};
